import { DataTablePrimeReact, TableERP } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getCatalogoByFilters, getCatalogoParams } from "api/Catalogo.service"
import { CatalogoReadingDtoProps } from "api/DTOs/CatalogoReadingDto"
import CustomConfirmDialog from "common/components/ConfirmDialog"
import Modal from "common/components/Modal/Modal"
import useToggle from "common/hooks/useToggle"
import createImgURI from "common/utils/createImgURI"
import { CATALOGOS_COLUMNS } from "features/Inventario/constants/catalogosColumns"
import { catalogosSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import {
  deleteCatalogo,
  getCatalogos,
} from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useSelector } from "hooks/useSelector"
import { Button } from "primereact/button"
import { DataTableRowClickEventParams } from "primereact/datatable"
import { ProgressSpinner } from "primereact/progressspinner"
import { TieredMenu } from "primereact/tieredmenu"
import { useCallback, useEffect, useRef, useState } from "react"
import { CameraOff } from "react-feather"
import { useTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import ShareCatalogo from "../ShareCatalogo/ShareCatalogo"
import "./catalogosItems.scss"

const CatalogosItems = ({ showCatalogosWithTable }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { catalogos, fetchingCatalogos } = useSelector(catalogosSelector)
  const [selectedCatalogo, setSelectedCatalogo] = useState(null)
  const [showDeleteCatalogoModal, toggleShowDeleteCatalogoModal] =
    useToggle(false)
  const [showModalShareCatalogo, toggleShowModalShareCatalogo] =
    useToggle(false)

  const dispatch = useDispatch()
  const history = useHistory()
  const refMenu = useRef()
  const onRowClick = async ({ data }: DataTableRowClickEventParams) => {
    history.push(ROUTES.VIEW_CATALOGO(data?.id))
  }
  const dtRef = useRef<DataTablePrimeReact<CatalogoReadingDtoProps[]> | null>(
    null
  )
  const fetchItems = useCallback(
    () => (queryParams: getCatalogoParams) =>
      getCatalogoByFilters({
        ...queryParams,
      }),
    []
  )
  const { items, isLoading } = useFilterMenu({
    serviceCall: fetchItems,
  })

  useEffect(() => {
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(getCatalogos())
  }, [dispatch])

  const menuItems = [
    {
      label: (
        <span>
          <FontAwesomeIcon
            className='icon-size-md icon-menu-mg'
            icon={["fal", "pen"]}
          />{" "}
          {t("catalogos.items.editCatalog")}
        </span>
      ),
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      command: () => history.push(ROUTES.EDIT_CATALOGO(selectedCatalogo.id)),
    },
    {
      label: (
        <span>
          <FontAwesomeIcon
            className='icon-size-md icon-menu-mg'
            icon={["fal", "share-nodes"]}
          />{" "}
          {t("catalogos.items.sendCatalog")}
        </span>
      ),
      command: toggleShowModalShareCatalogo,
    },
    {
      label: (
        <span>
          <FontAwesomeIcon
            className='icon-size-md icon-menu-mg'
            icon={["fal", "eye"]}
          />{" "}
          {t("catalogos.items.seeCatalog")}
        </span>
      ),
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      command: () => history.push(ROUTES.VIEW_CATALOGO(selectedCatalogo.id)),
    },
    {
      label: (
        <span>
          <FontAwesomeIcon
            className='icon-size-md icon-menu-mg'
            icon={["fal", "trash-alt"]}
          />{" "}
          {t("catalogos.items.deleteCatalog")}
        </span>
      ),
      command: () => toggleShowDeleteCatalogoModal(),
    },
  ]

  const handleDeleteCatalogo = () =>
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    dispatch(deleteCatalogo(selectedCatalogo?.id))

  const openAction = (e: $TSMigrationFixMe, catalogo: $TSMigrationFixMe) => {
    setSelectedCatalogo(catalogo)
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    refMenu.current.toggle(e)
  }

  return (
    <div className='wrap-catalogos-items'>
      {!showCatalogosWithTable ? (
        fetchingCatalogos ? (
          <div className='spinner-loader'>
            <ProgressSpinner />
          </div>
        ) : (
          <div className='catalogos-items-container'>
            {catalogos.map((catalogo: $TSMigrationFixMe) => (
              <div
                key={catalogo.id}
                className='catalogo-item'
              >
                <Link
                  title={`${t("catalogos.items.titleLink")}`}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    width: "100%",
                  }}
                  to={ROUTES.VIEW_CATALOGO(catalogo.id)}
                >
                  <div className='catalogo-image'>
                    {catalogo.imagenBase64 ? (
                      <img
                        src={createImgURI(
                          catalogo.imagenBase64,
                          catalogo.imagenMediaType
                        )}
                        alt={`${t("catalogos.items.altItem")} ${
                          catalogo.nombre
                        }`}
                      />
                    ) : (
                      <CameraOff size={50} />
                    )}
                  </div>

                  <p className='catalogo-name'>{catalogo.nombre}</p>
                </Link>

                <div className='catalogo-footer'>
                  <Button
                    icon='pi pi-ellipsis-v'
                    style={{ width: "10px" }}
                    className='p-button-text p-button-secondary'
                    aria-controls='menu-catalogo'
                    aria-haspopup
                    onClick={(e) => openAction(e, catalogo)}
                  />
                  <span>
                    {t("catalogos.items.titleArticucle")}{" "}
                    {catalogo.cantidadArticulos}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        <>
          <div className='tw-flex tw-flex-col tw-h-[calc(100dvh-160px)] tw-relative '>
            <div className='tw-h-full tw-min-h-0'>
              <TableERP
                refTable={dtRef}
                columns={CATALOGOS_COLUMNS(t)}
                className='tw-h-full !tw-z-0'
                columnResizeMode='expand'
                removableSort
                value={items as CatalogoReadingDtoProps[]}
                showGridlines
                lazy
                dataKey='id'
                scrollable
                size='small'
                onRowClick={onRowClick}
                loading={isLoading}
                emptyMessage={t("primeReact.table.emptyMessage")}
              />
            </div>
          </div>
        </>
      )}
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <TieredMenu
        style={{ width: "214px" }}
        model={menuItems}
        popup
        ref={refMenu}
        id='menu-catalogo'
      />
      <CustomConfirmDialog
        visible={showDeleteCatalogoModal}
        onHide={toggleShowDeleteCatalogoModal}
        closable
        message={
          <span>
            {t("catalogos.deleteModal.deleteMsg")}
            {' "'}
            {/* @ts-expect-error TS(2339): Property 'nombre' does not exist on */}
            {selectedCatalogo?.nombre}
            &quot;?
          </span>
        }
        header={
          <div className='d-flex justify-content-start'>
            <h6>{t("catalogos.deleteModal.deleteButton")}</h6>
          </div>
        }
        acceptLabel={`${t("catalogos.deleteModal.acceptButton")}`}
        rejectLabel={`${t("catalogos.deleteModal.rejectButton")}`}
        accept={handleDeleteCatalogo}
      />
      <Modal
        header={`${t("catalogos.compartir.headerTitle")}`}
        visible={showModalShareCatalogo}
        onHide={toggleShowModalShareCatalogo}
      >
        <ShareCatalogo
          catalogo={selectedCatalogo}
          onHide={toggleShowModalShareCatalogo}
        />
      </Modal>
    </div>
  )
}

export default CatalogosItems
